'use client';

import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { UccDefaultProps, UccModalContentProps } from './modal.types';

type UccModalContentPropsFallback = UccModalContentProps &
  Required<UccDefaultProps>;

const UccModalDataContext = createContext<UccModalContentPropsFallback | null>(
  null,
);

export function UccModalDataProvider({
  id = 'connect-me-modal',
  metricName = 'connect-me',
  autoTrigger = true,
  autoTriggerDelay = 0,
  children,
  ...props
}: UccModalContentProps & { children: ReactNode }) {
  return (
    <UccModalDataContext.Provider
      value={{
        id,
        metricName,
        autoTrigger,
        autoTriggerDelay,
        ...props,
      }}
    >
      {children}
    </UccModalDataContext.Provider>
  );
}

export function useUccModalDataContext() {
  const data = useContext(UccModalDataContext);

  if (data === null) {
    throw new Error(
      'A component using `useUccModalDataContext` must be a descendant of `UccModalDataProvider`.',
    );
  }

  return data;
}
